export enum ConnectedAccountApiPath {
    CONNECTED_ACCOUNT = 'billings/connectedAccount',
    CONNECTED_ACCOUNT_SESSION = 'billings/connectedAccount/session',
}
